import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslocoModule } from '@jsverse/transloco';
import { MultiselectEditComponent } from './multiselect-edit.component';
import { UiModule } from '@eg/ui';

@NgModule({
  declarations: [MultiselectEditComponent],
  imports: [CommonModule, FlexLayoutModule, TranslocoModule, UiModule],
  exports: [MultiselectEditComponent],
})
export class MultiselectEditModule {}
